import { useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import "./../accounts-header/account-header.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { getAccountsUrl } from "../../../utils/accountsUrl";
import { getApiUrl } from "../../../utils/baseUrl";
import { getComplianceApiUrl } from "../../../utils/getComplianceApiUrl";
import { getRpsApiUrl } from "../../../utils/getRpsApiUrl";
import { globalGetApiUrl } from "../../../utils/globalBaseUrl";
import { getIntelUrl } from "../../../utils/intelUrl";
import { getPaymentsUrl } from "../../../utils/paymentsUrl";
import { getSanctionsUrl } from "../../../utils/sanctionsUrl";
import { getTradeComplianceUrl } from "../../../utils/tradeComplianceUrl";
import { getWebsiteUrl } from "../../../utils/websiteUrls";
import Loader from "../../Loader";
import LocalStorageService from "./../../../core/services/local-storage.service";
import ProductLinkingDropdown from "./header-product-linking-dropdown";
import { umsRedirection } from "./header-product-linking-dropdown-list";
const upgradePlansDictionary = require("../../../core/dictionary/upgrade-plans").getUpgradePlansDictionary();
const upgradeMexicoPlansDictionary = require("../../../core/dictionary/upgrade-mx-plans").getUpgradeMxPlansDictionary();
const upgradeUkPlansDictionary = require("../../../core/dictionary/upgrade-uk-plans").getUpgradeUkPlansDictionary();
const upgradeCanadaPlansDictionary = require("../../../core/dictionary/upgrade-ca-plans").getUpgradeCaPlansDictionary();
const upgradeColombiaPlansDictionary = require("../../../core/dictionary/upgrade-co-plans").getUpgradeCOPlansDictionary();
const upgradePeruPlansDictionary = require("../../../core/dictionary/upgrade-pr-plans").getUpgradePRPlansDictionary();
const upgradeEcuadorPlansDictionary = require("../../../core/dictionary/upgrade-ec-plans").getUpgradeEcPlansDictionary();
const upgradeArgentinaPlansDictionary = require("../../../core/dictionary/upgrade-ar-plans").getUpgradeArPlansDictionary();
const upgradePanamaPlansDictionary = require("../../../core/dictionary/upgrade-panama-plans").getUpgradePanamaPlansDictionary();
const upgradeBrazilPlansDictionary = require("../../../core/dictionary/upgrade-br-plans").getUpgradeBrazilPlansDictionary();
const upgradeChilePlansDictionary = require("../../../core/dictionary/upgrade-ch-plans").getUpgradeChPlansDictionary();
const upgradeUruguayPlansDictionary = require("../../../core/dictionary/upgrade-uy-plans").getUpgradeUruguayPlansDictionary();
const upgradeSasPlansDictionary = require("../../../core/dictionary/upgrade-sas-plans").getUpgradeSasPlansDictionary();
const upgradePhPlansDictionary = require("../../../core/dictionary/upgrade-ph-plans").getupgradePhPlansDictionary();
const upgradeVnPlansDictionary = require("../../../core/dictionary/upgrade-vn-plans").getupgradeVnPlansDictionary();
const upgradeInPlansDictionary = require("../../../core/dictionary/upgrade-in-plans").getupgradeInPlansDictionary();
const localProductDictionary = {
  intelUs: "intel-us",
  intelUk: "intel-uk",
  intelMexico: "intel-mexico",
  intelMexicoOld: "intel-mexico-old",
  intelCanada: "intel-canada",
  intelPeru: "intel-peru",
  intelColombia: "intel-colombia",
  intelEcuador: "intel-ecuador",
  intelPanama: "intel-panama",
  intelArgentina: "intel-argentina",
  intelBrazil: "intel-brazil",
  intelChile: "intel-chile",
  intelUruguay: "intel-uruguay",
  intelIndonesia: "intel-indonesia",
  intelPhilippines: "intel-philippines",
  intelVietnam: "intel-vietnam",
  intelIndia: "intel-india",
};

const navigation = {
  search: "search",
  upgrade: "upgrade",
};
const intelHeader = {
  logoutUser: globalGetApiUrl("auth/logout"),
  profile: globalGetApiUrl("auth/getUserProfileComplete"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  getPlansByUserId: getComplianceApiUrl("trademo/tc/getPlansByUserId"),
  getRpsPlan: getRpsApiUrl("trademo/rps/getUserPlan"),
};

const localStorageService = LocalStorageService.getService();
const dataSourceOptions = [
  {
    value: localProductDictionary.intelUs,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="US" svg />
        <span>US Imports</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelUs,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="US" svg />
        <span>US Exports</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelMexico,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="MX" svg />
        <span>Mexico Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelCanada,
    label: (
      <div className="d-none">
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CA" svg />
        <span>Canada</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelColombia,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CO" svg />
        <span>Colombia Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelColombia,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CO" svg />
        <span>Colombia Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelPeru,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PE" svg />
        <span>Peru Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelEcuador,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="EC" svg />
        <span>Ecuador Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelEcuador,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="EC" svg />
        <span>Ecuador Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelArgentina,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="AR" svg />
        <span>Argentina Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelPanama,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PA" svg />
        <span>Panama Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelPanama,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PA" svg />
        <span>Panama Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelBrazil,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="BR" svg />
        <span>Brazil Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelBrazil,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="BR" svg />
        <span>Brazil Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelUruguay,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="UY" svg />
        <span>Uruguay Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelUruguay,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="UY" svg />
        <span>Uruguay Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelMexico,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="MX" svg />
        <span>Mexico Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelChile,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CL" svg />
        <span>Chile Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelChile,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CL" svg />
        <span>Chile Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelPeru,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PE" svg />
        <span>Peru Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelUk,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="GB" svg />
        <span>UK Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelUk,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="GB" svg />
        <span>UK Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelArgentina,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="AR" svg />
        <span>Argentina Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelIndonesia,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="ID" svg />
        <span>Indonesia Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelIndonesia,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="ID" svg />
        <span>Indonesia Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelPhilippines,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PH" svg />
        <span>Philippines Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelPhilippines,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PH" svg />
        <span>Philippines Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelVietnam,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="VN" svg />
        <span>Vietnam Export</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelVietnam,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="VN" svg />
        <span>Vietnam Import</span>
      </div>
    ),
  },
  {
    value: localProductDictionary.intelIndia,
    label: (
      <div>
        <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="IN" svg />
        <span>India Import</span>
      </div>
    ),
  },
];

const mexicoBlockUsers = {
  "paola.gomez@mx.dsv.com": true,
  "ville.mattila@mx.dsv.com": true,
  "milagros.hasselmeyer@mx.dsv.com": true,
  "arindam@test.com": true,
  "testingmexico2@trademo.com": true,
};
export default function AccountHeader({ setCreditDetails }) {
  const [fullName, setfullName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [userplan, setPlanDetails] = useState("");
  const [usExportFlag, setUSExportFlag] = useState(false);
  const [isStatusActive, setActiveStatus] = useState(null);
  const [isVerified, setIsVerified] = useState(null);
  const [initials, setInitials] = useState("");
  const [currentProduct, setCurrentProduct] = useState("");
  const [userPlans, setUserPlans] = useState([]);
  const [userProductAccess, setUserProductAccess] = useState([]);
  const [userRpsPlans, setUserRpsPlans] = useState([]);
  const [plansData, setPlansData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [userData, setUserData] = useState({});
  const [parentProductArr, setParentProductArr] = useState([]);
  const [mainDataSourceGroupedOptions, setMainDataSourceGroupedOptions] = useState([
    {
      label: "Select data source",
      options: dataSourceOptions,
    },
  ]);
  const [isAccountExpired, setIsAccountExpired] = useState(false);
  const [isComplianceAccountExpired, setIsComplianceAccountExpired] = useState(false);
  const [isSanctionsAccoundExpired, setIsSanctionsAccoundExpired] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    setCurrentProduct(localStorageService.getUserProduct());
    setIsAccountExpired(!!localStorageService.getExpiryStatus() && localStorageService.getExpiryStatus() === true ? true : false);
    setIsComplianceAccountExpired(
      !!localStorageService.getUserData() && localStorageService.getUserData().isExpired !== "" && localStorageService.getUserData().isExpired ? true : false
    );
    if (localStorageService.getUserDetails()) {
      setfullName(
        !!localStorageService.getUserDetails().full_name && localStorageService.getUserDetails().full_name !== "" ? localStorageService.getUserDetails().full_name : null
      );
      getInitials(!!localStorageService.getUserDetails().full_name && localStorageService.getUserDetails().full_name !== "" ? localStorageService.getUserDetails().full_name : "");
      setEmailId(
        !!localStorageService.getUserDetails().email_address && localStorageService.getUserDetails().email_address !== ""
          ? localStorageService.getUserDetails().email_address
          : null
      );
      if (!!localStorageService.getUserDetails().active_status && localStorageService.getUserDetails().active_status === true) {
        setActiveStatus(localStorageService.getUserDetails().active_status);
      } else {
        getUserData();
      }
      // if(window.location.href.includes('compliance')){
      // }
    } else {
      getUserData();
    }
    if (window.location.href.includes("compliance")) {
      callGetPlansByUserId();
    } else if (window.location.href.includes("sanctions")) {
      getRPSPlansDetailsApi();
    }
    getUserPlan();
    let urlStr = window.location.href;
    if (urlStr.includes("?verified=true")) {
      setIsVerified(true);
      setTimeout(() => {
        setIsVerified(false);
      }, 20000);
    } else {
      setIsVerified(false);
    }
  }, []);

  const getUserData = () => {
    let params = {};
    axios
      .get(intelHeader.profile, { params })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        setUserData(data);
        setfullName(data.fullName);
        getInitials(data.fullName);
        setEmailId(data.email);
        const localStorageUserDetails = {
          full_name: data.fullName,
          active_status: data.isActive,
          email_address: data.email,
        };
        localStorageService.setDataToLocalStorage("userAccountDetails", localStorageUserDetails);
        const { isInternalAdmin, isInternalUser, isAdmin } = data;
        setIsAdmin(isInternalAdmin || isInternalUser || isAdmin);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getInitials = (string) => {
    let names = string.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    setInitials(initials);
    return initials;
  };

  const getRPSPlansDetailsApi = () => {
    setLoader(true);
    axios
      .get(intelHeader.getRpsPlan)
      .then((res) => {
        if (res && res.data && res.data.data && res.data.status.toLowerCase() === "success") {
          const localStorageData = res.data.data;
          setUserRpsPlans(localStorageData);
          localStorageService.setDataToLocalStorage("userRpsPlanDetails", localStorageData);
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getUserPlan = () => {
    axios
      .get(intelHeader.getUserPlanDetails)
      .then((res) => {
        if (!!res && !!res.data && !!res.data.data && !!res.data.data.length > 0) {
          setCreditDetails(res.data.credit_details);
          if (res.data.data.length > 1) {
            let usPlan = "";
            let mexicoPlan = "";
            let ukPlan = "";
            let canadaPlan = "";
            let colombiaPlan = "";
            let peruPlan = "";
            let ecuadorPlan = "";
            let argentinaPlan = "";
            let panamaPlan = "";
            let brazilPlan = "";
            let chilePlan = "";
            let uruguayPlan = "";
            let idonesiaPlan = "";
            let philippinesPlan = "";
            let vietnamPlan = "";
            let indiaPlan = "";
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].user_active_plan.includes("_us_")) {
                usPlan = res.data.data[i].user_active_plan;
                var tempFlagValue = false;
                if (
                  !!usPlan &&
                  usPlan !== "" &&
                  (usPlan === upgradePlansDictionary.trademo_intel_us_starter.key ||
                    usPlan === upgradePlansDictionary.trademo_intel_us_pro2.key ||
                    usPlan === upgradePlansDictionary.trademo_intel_us_pro_lite.key ||
                    usPlan === upgradePlansDictionary.trademo_intel_us_advanced.key ||
                    usPlan === upgradePlansDictionary.trademo_intel_us_enterprise.key)
                ) {
                  tempFlagValue = true;
                  setUSExportFlag(true);
                }
              }
              if (res.data.data[i].user_active_plan.includes("_mx_")) {
                mexicoPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_uk_")) {
                ukPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_ca_")) {
                canadaPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_co_")) {
                colombiaPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_pr_")) {
                peruPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_ec_")) {
                ecuadorPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_ar_")) {
                argentinaPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_pa_")) {
                panamaPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_br_")) {
                brazilPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_ch_")) {
                chilePlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_uy_")) {
                uruguayPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_sas_")) {
                idonesiaPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_ph_")) {
                philippinesPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_vn_")) {
                vietnamPlan = res.data.data[i].user_active_plan;
              }
              if (res.data.data[i].user_active_plan.includes("_in_")) {
                indiaPlan = res.data.data[i].user_active_plan;
              }
            }
            if (localStorageService.getUserProduct() === "intel-mexico") {
              setPlanDetails(mexicoPlan);
            } else if (localStorageService.getUserProduct() === "intel-uk") {
              setPlanDetails(ukPlan);
            } else if (localStorageService.getUserProduct() === "intel-canada") {
              setPlanDetails(canadaPlan);
            } else if (localStorageService.getUserProduct() === "intel-ecuador") {
              setPlanDetails(ecuadorPlan);
            } else if (localStorageService.getUserProduct() === "intel-argentina") {
              setPlanDetails(argentinaPlan);
            } else if (localStorageService.getUserProduct() === "intel-colombia") {
              setPlanDetails(colombiaPlan);
            } else if (localStorageService.getUserProduct() === "intel-peru") {
              setPlanDetails(peruPlan);
            } else if (localStorageService.getUserProduct() === "intel-panama") {
              setPlanDetails(panamaPlan);
            } else if (localStorageService.getUserProduct() === "intel-brazil") {
              setPlanDetails(brazilPlan);
            } else if (localStorageService.getUserProduct() === "intel-chile") {
              setPlanDetails(chilePlan);
            } else if (localStorageService.getUserProduct() === "intel-indonesia") {
              setPlanDetails(idonesiaPlan);
            } else if (localStorageService.getUserProduct() === "intel-philippines") {
              setPlanDetails(philippinesPlan);
            } else if (localStorageService.getUserProduct() === "intel-vietnam") {
              setPlanDetails(vietnamPlan);
            } else if (localStorageService.getUserProduct() === "intel-india") {
              setPlanDetails(indiaPlan);
            } else {
              setPlanDetails(usPlan);
            }
          } else {
            setPlanDetails(res.data.data[0].user_active_plan);
            tempFlagValue = false;
            if (
              !!res.data.data[0].user_active_plan &&
              res.data.data[0].user_active_plan !== "" &&
              (res.data.data[0].user_active_plan === upgradePlansDictionary.trademo_intel_us_starter.key ||
                res.data.data[0].user_active_plan === upgradePlansDictionary.trademo_intel_us_pro2.key ||
                res.data.data[0].user_active_plan === upgradePlansDictionary.trademo_intel_us_pro_lite.key ||
                res.data.data[0].user_active_plan === upgradePlansDictionary.trademo_intel_us_advanced.key ||
                res.data.data[0].user_active_plan === upgradePlansDictionary.trademo_intel_us_enterprise.key)
            ) {
              tempFlagValue = true;
              setUSExportFlag(true);
            }
          }
          setUserPlans(res.data.data);
          let tempUserProductArray = [];
          let tempOptionsArr = [];
          for (let i = 0; i < res.data.data.length; i++) {
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_free.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_plus.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_basic.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_pro.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_essential.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_starter.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_pro2.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_pro_lite.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_advanced.key ||
                res.data.data[i].user_active_plan === upgradePlansDictionary.trademo_intel_us_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelUs);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeMexicoPlansDictionary.trademo_intel_mx_free.key ||
                res.data.data[i].user_active_plan === upgradeMexicoPlansDictionary.trademo_intel_mx_plus.key ||
                res.data.data[i].user_active_plan === upgradeMexicoPlansDictionary.trademo_intel_mx_pro.key ||
                res.data.data[i].user_active_plan === upgradeMexicoPlansDictionary.trademo_intel_mx_pro2.key ||
                res.data.data[i].user_active_plan === upgradeMexicoPlansDictionary.trademo_intel_mx_advanced.key ||
                res.data.data[i].user_active_plan === upgradeMexicoPlansDictionary.trademo_intel_mx_enterprise.key ||
                res.data.data[i].user_active_plan === upgradeMexicoPlansDictionary.trademo_intel_mx_essential.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelMexico);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeUkPlansDictionary.trademo_intel_uk_enterprise.key ||
                res.data.data[i].user_active_plan === upgradeUkPlansDictionary.trademo_intel_uk_enterprise.key ||
                res.data.data[i].user_active_plan === upgradeUkPlansDictionary.trademo_intel_uk_pro.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelUk);
            }
            if (res.data.data[i].navigate === navigation.search && res.data.data[i].user_active_plan === upgradeCanadaPlansDictionary.trademo_intel_ca_pro.key) {
              tempUserProductArray.push(localProductDictionary.intelCanada);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeColombiaPlansDictionary.trademo_intel_co_pro.key ||
                res.data.data[i].user_active_plan === upgradeColombiaPlansDictionary.trademo_intel_co_advanced.key ||
                res.data.data[i].user_active_plan === upgradeColombiaPlansDictionary.trademo_intel_co_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelColombia);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeBrazilPlansDictionary.trademo_intel_br_pro.key ||
                res.data.data[i].user_active_plan === upgradeBrazilPlansDictionary.trademo_intel_br_advanced.key ||
                res.data.data[i].user_active_plan === upgradeBrazilPlansDictionary.trademo_intel_br_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelBrazil);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeChilePlansDictionary.trademo_intel_ch_pro.key ||
                res.data.data[i].user_active_plan === upgradeChilePlansDictionary.trademo_intel_ch_advanced.key ||
                res.data.data[i].user_active_plan === upgradeChilePlansDictionary.trademo_intel_ch_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelChile);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeUruguayPlansDictionary.trademo_intel_uy_pro.key ||
                res.data.data[i].user_active_plan === upgradeUruguayPlansDictionary.trademo_intel_uy_advanced.key ||
                res.data.data[i].user_active_plan === upgradeUruguayPlansDictionary.trademo_intel_uy_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelUruguay);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradePeruPlansDictionary.trademo_intel_pr_pro.key ||
                res.data.data[i].user_active_plan === upgradePeruPlansDictionary.trademo_intel_pr_advanced.key ||
                res.data.data[i].user_active_plan === upgradePeruPlansDictionary.trademo_intel_pr_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelPeru);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeEcuadorPlansDictionary.trademo_intel_ec_pro.key ||
                res.data.data[i].user_active_plan === upgradeEcuadorPlansDictionary.trademo_intel_ec_advanced.key ||
                res.data.data[i].user_active_plan === upgradeEcuadorPlansDictionary.trademo_intel_ec_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelEcuador);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeArgentinaPlansDictionary.trademo_intel_ar_pro.key ||
                res.data.data[i].user_active_plan === upgradeArgentinaPlansDictionary.trademo_intel_ar_advanced.key ||
                res.data.data[i].user_active_plan === upgradeArgentinaPlansDictionary.trademo_intel_ar_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelArgentina);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradePanamaPlansDictionary.trademo_intel_pa_pro.key ||
                res.data.data[i].user_active_plan === upgradePanamaPlansDictionary.trademo_intel_pa_advanced.key ||
                res.data.data[i].user_active_plan === upgradePanamaPlansDictionary.trademo_intel_pa_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelPanama);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeSasPlansDictionary.trademo_intel_sas_pro.key ||
                res.data.data[i].user_active_plan === upgradeSasPlansDictionary.trademo_intel_sas_advanced.key ||
                res.data.data[i].user_active_plan === upgradeSasPlansDictionary.trademo_intel_sas_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelIndonesia);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradePhPlansDictionary.trademo_intel_ph_pro.key ||
                res.data.data[i].user_active_plan === upgradePhPlansDictionary.trademo_intel_ph_advanced.key ||
                res.data.data[i].user_active_plan === upgradePhPlansDictionary.trademo_intel_ph_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelPhilippines);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeVnPlansDictionary.trademo_intel_vn_pro.key ||
                res.data.data[i].user_active_plan === upgradeVnPlansDictionary.trademo_intel_vn_advanced.key ||
                res.data.data[i].user_active_plan === upgradeVnPlansDictionary.trademo_intel_vn_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelVietnam);
            }
            if (
              res.data.data[i].navigate === navigation.search &&
              (res.data.data[i].user_active_plan === upgradeInPlansDictionary.trademo_intel_in_pro.key ||
                res.data.data[i].user_active_plan === upgradeInPlansDictionary.trademo_intel_in_advanced.key ||
                res.data.data[i].user_active_plan === upgradeInPlansDictionary.trademo_intel_in_enterprise.key)
            ) {
              tempUserProductArray.push(localProductDictionary.intelIndia);
            }
          }
          setUserProductAccess(tempUserProductArray);
          if (tempUserProductArray.includes(localProductDictionary.intelUs) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelUs,
              label: (
                <div id="us-import">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="US" svg />
                  <span>US Imports</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelUs,
              label: (
                <div id="us-import">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="US" svg />
                  <span>US Imports</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelUs) === true && tempFlagValue === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelUs,
              label: (
                <div id="us-export">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="US" svg />
                  <span>US Exports</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelUs,
              label: (
                <div id="us-export">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="US" svg />
                  <span>US Exports</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelMexico) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelMexico,
              label: (
                <div id="mexico-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="MX" svg />
                  <span>Mexico Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelMexico,
              label: (
                <div id="mexico-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="MX" svg />
                  <span>Mexico Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelMexico) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelMexico,
              label: (
                <div id="mexico-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="MX" svg />
                  <span>Mexico Imports</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelMexico,
              label: (
                <div id="mexico-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="MX" svg />
                  <span>Mexico Imports</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelUk) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelUk,
              label: (
                <div id="uk-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="GB" svg />
                  <span>UK Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelUk,
              label: (
                <div id="uk-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="GB" svg />
                  <span>UK Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelUk) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelUk,
              label: (
                <div id="uk-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="GB" svg />
                  <span>UK Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelUk,
              label: (
                <div id="uk-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="GB" svg />
                  <span>UK Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelChile) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelChile,
              label: (
                <div id="chile-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CL" svg />
                  <span>Chile Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelChile,
              label: (
                <div id="chile-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CL" svg />
                  <span>Chile Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelChile) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelChile,
              label: (
                <div id="chile-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CL" svg />
                  <span>Chile Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelChile,
              label: (
                <div id="chile-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CL" svg />
                  <span>Chile Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelArgentina) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelArgentina,
              label: (
                <div>
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="AR" svg />
                  <span>Argentina Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelArgentina,
              label: (
                <div>
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="AR" svg />
                  <span>Argentina Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelArgentina) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelArgentina,
              label: (
                <div>
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="AR" svg />
                  <span>Argentina Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelArgentina,
              label: (
                <div>
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="AR" svg />
                  <span>Argentina Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelCanada) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelCanada,
              label: (
                <div className="d-none">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CA" svg />
                  <span>Canada</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelCanada,
              label: (
                <div className="d-none">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CA" svg />
                  <span>Canada</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelColombia) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelColombia,
              label: (
                <div id="colombia-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CO" svg />
                  <span>Colombia Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelColombia,
              label: (
                <div id="colombia-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CO" svg />
                  <span>Colombia Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelColombia) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelColombia,
              label: (
                <div id="colombia-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CO" svg />
                  <span>Colombia Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelColombia,
              label: (
                <div id="colombia-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="CO" svg />
                  <span>Colombia Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelPeru) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelPeru,
              label: (
                <div id="peru-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PE" svg />
                  <span>Peru Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelPeru,
              label: (
                <div id="peru-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PE" svg />
                  <span>Peru Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelPeru) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelPeru,
              label: (
                <div id="peru-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PE" svg />
                  <span>Peru Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelPeru,
              label: (
                <div id="peru-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PE" svg />
                  <span>Peru Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelEcuador) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelEcuador,
              label: (
                <div id="ecuador-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="EC" svg />
                  <span>Ecuador Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelEcuador,
              label: (
                <div id="ecuador-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="EC" svg />
                  <span>Ecuador Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelEcuador) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelEcuador,
              label: (
                <div id="ecuador-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="EC" svg />
                  <span>Ecuador Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelEcuador,
              label: (
                <div id="ecuador-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="EC" svg />
                  <span>Ecuador Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelPanama) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelPanama,
              label: (
                <div id="panama-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PA" svg />
                  <span>Panama Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelPanama,
              label: (
                <div id="panama-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PA" svg />
                  <span>Panama Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelPanama) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelPanama,
              label: (
                <div id="panama-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PA" svg />
                  <span>Panama Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelPanama,
              label: (
                <div id="panama-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PA" svg />
                  <span>Panama Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }

          if (tempUserProductArray.includes(localProductDictionary.intelBrazil) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelBrazil,
              label: (
                <div id="brazil-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="BR" svg />
                  <span>Brazil Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelBrazil,
              label: (
                <div id="brazil-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="BR" svg />
                  <span>Brazil Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelBrazil) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelBrazil,
              label: (
                <div id="brazil-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="BR" svg />
                  <span>Brazil Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelBrazil,
              label: (
                <div id="brazil-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="BR" svg />
                  <span>Brazil Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }

          if (tempUserProductArray.includes(localProductDictionary.intelUruguay) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelUruguay,
              label: (
                <div id="uruguay-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="UY" svg />
                  <span>Uruguay Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelUruguay,
              label: (
                <div id="uruguay-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="UY" svg />
                  <span>Uruguay Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelUruguay) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelUruguay,
              label: (
                <div id="uruguay-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="UY" svg />
                  <span>Uruguay Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelUruguay,
              label: (
                <div id="uruguay-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="UY" svg />
                  <span>Uruguay Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelIndonesia) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndonesia,
              label: (
                <div id="indonesia-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="ID" svg />
                  <span>Indonesia Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndonesia,
              label: (
                <div id="indonesia-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="ID" svg />
                  <span>Indonesia Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelIndonesia) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndonesia,
              label: (
                <div id="indonesia-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="ID" svg />
                  <span>Indonesia Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndonesia,
              label: (
                <div id="indonesia-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="ID" svg />
                  <span>Indonesia Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelPhilippines) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelPhilippines,
              label: (
                <div id="philippines-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PH" svg />
                  <span>Philippines Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelPhilippines,
              label: (
                <div id="philippines-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PH" svg />
                  <span>Philippines Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelPhilippines) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelPhilippines,
              label: (
                <div id="philippines-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PH" svg />
                  <span>Philippines Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelPhilippines,
              label: (
                <div id="philippines-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="PH" svg />
                  <span>Philippines Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelVietnam) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelVietnam,
              label: (
                <div id="vietnam-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="VN" svg />
                  <span>Vietnam Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelVietnam,
              label: (
                <div id="vietnam-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="VN" svg />
                  <span>Vietnam Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelVietnam) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelVietnam,
              label: (
                <div id="vietnam-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="VN" svg />
                  <span>Vietnam Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelVietnam,
              label: (
                <div id="vietnam-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="VN" svg />
                  <span>Vietnam Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelIndia) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndia,
              label: (
                <div id="india-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="IN" svg />
                  <span>India Import</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndia,
              label: (
                <div id="india-imports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="IN" svg />
                  <span>India Import</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          if (tempUserProductArray.includes(localProductDictionary.intelIndia) === true) {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndia,
              label: (
                <div id="india-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="IN" svg />
                  <span>India Export</span>
                </div>
              ),
            });
          } else {
            tempOptionsArr.push({
              value: localProductDictionary.intelIndia,
              label: (
                <div id="india-exports">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode="IN" svg />
                  <span>India Export</span>
                  <span className="float-right trademo-link">Subscribe</span>
                </div>
              ),
            });
          }
          setMainDataSourceGroupedOptions([
            {
              label: "Select data source",
              options: tempOptionsArr,
            },
          ]);
        } else {
          setPlanDetails("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const bindDataSource = (data, label) => {
    let userData = localStorageService.getUserData();
    userData.current_product = data;
    let url = "";
    let tempUsPlan = "";
    let tempMxPlan = "";
    let tempUkPlan = "";
    let tempCaPlan = "";
    let tempCoPlan = "";
    let tempPrPlan = "";
    let tempEcPlan = "";
    let tempArPlan = "";
    let tempPaPlan = "";
    let tempBrPlan = "";
    let tempChPlan = "";
    let tempUyPlan = "";
    let tempSasPlan = "";
    let tempPhPlan = "";
    let tempVnPlan = "";
    let tempInPlan = "";
    for (let i = 0; i < userPlans.length; i++) {
      if (userPlans[i].user_active_plan.includes("_us_")) {
        tempUsPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_mx_")) {
        tempMxPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_uk_")) {
        tempUkPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_ca_")) {
        tempCaPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_co_")) {
        tempCoPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_pr_")) {
        tempPrPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_br_")) {
        tempBrPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_ch_")) {
        tempChPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_ec_")) {
        tempEcPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_ar_")) {
        tempArPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_pa_")) {
        tempPaPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_uy_")) {
        tempUyPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_sas_")) {
        tempSasPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_ph_")) {
        tempPhPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_vn_")) {
        tempVnPlan = userPlans[i].user_active_plan;
      }
      if (userPlans[i].user_active_plan.includes("_in_")) {
        tempInPlan = userPlans[i].user_active_plan;
      }
    }
    // localStorageService.setDataToLocalStorage('userData', userData);
    url =
      getIntelUrl() +
      "intel?T=" +
      localStorageService.getAccessToken() +
      "&I=" +
      localStorageService.getSessionID() +
      "&D=" +
      localStorageService.getSessionExpiryDate() +
      "&Type=D&P=" +
      data +
      "&Email=" +
      emailId +
      "&OId=" +
      (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 1);
    if (data === localProductDictionary.intelUs) {
      if (userProductAccess.includes(localProductDictionary.intelUs) === true) {
        const tempPlanObj = { user_active_plan: tempUsPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        if (label.props.id === "us-export" && usExportFlag === true) {
          window.location.href = getIntelUrl() + "us-exports-search";
        } else if (label.props.id === "us-import") {
          window.location.href = getIntelUrl() + "search-shipments";
        } else {
          callNavigation("plans", data);
        }
        // window.location.href = url;
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelCanada) {
      if (userProductAccess.includes(localProductDictionary.intelCanada) === true) {
        const tempCaPlanObj = { user_active_plan: tempCaPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempCaPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        window.location.href = url;
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelPeru) {
      if (userProductAccess.includes(localProductDictionary.intelPeru) === true) {
        const tempPrPlanObj = { user_active_plan: tempPrPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempPrPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        if (label.props.id === "peru-exports") {
          window.location.href = getIntelUrl() + "peru-search-export";
        } else if (label.props.id === "peru-imports") {
          window.location.href = getIntelUrl() + "peru-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelColombia) {
      if (userProductAccess.includes(localProductDictionary.intelColombia) === true) {
        const tempCoPlanObj = { user_active_plan: tempCoPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempCoPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        // window.location.href = url;
        if (label.props.id === "colombia-exports") {
          window.location.href = getIntelUrl() + "colombia-search-export";
        } else if (label.props.id === "colombia-imports") {
          window.location.href = getIntelUrl() + "colombia-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelBrazil) {
      if (userProductAccess.includes(localProductDictionary.intelBrazil) === true) {
        const tempBrPlanObj = { user_active_plan: tempBrPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempBrPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        // window.location.href = url;
        if (label.props.id === "brazil-exports") {
          window.location.href = getIntelUrl() + "brazil-search-export";
        } else if (label.props.id === "brazil-imports") {
          window.location.href = getIntelUrl() + "brazil-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelChile) {
      if (userProductAccess.includes(localProductDictionary.intelChile) === true) {
        const tempChPlanObj = { user_active_plan: tempChPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempChPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        // window.location.href = url;
        if (label.props.id === "chile-exports") {
          window.location.href = getIntelUrl() + "chile-search-export";
        } else if (label.props.id === "chile-imports") {
          window.location.href = getIntelUrl() + "chile-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelUruguay) {
      if (userProductAccess.includes(localProductDictionary.intelUruguay) === true) {
        const tempUyPlanObj = { user_active_plan: tempUyPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempUyPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        // window.location.href = url;
        if (label.props.id === "uruguay-exports") {
          window.location.href = getIntelUrl() + "uruguay-search-export";
        } else if (label.props.id === "uruguay-imports") {
          window.location.href = getIntelUrl() + "uruguay-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelEcuador) {
      if (userProductAccess.includes(localProductDictionary.intelEcuador) === true) {
        const tempEcPlanObj = { user_active_plan: tempEcPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempEcPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        // window.location.href = url;
        if (label.props.id === "ecuador-exports") {
          window.location.href = getIntelUrl() + "ecuador-search-export";
        } else if (label.props.id === "ecuador-imports") {
          window.location.href = getIntelUrl() + "ecuador-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelPanama) {
      if (userProductAccess.includes(localProductDictionary.intelPanama) === true) {
        const tempPaPlanObj = { user_active_plan: tempPaPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempPaPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        // window.location.href = url;
        if (label.props.id === "panama-imports") {
          window.location.href = getIntelUrl() + "panama-search-import";
        } else if (label.props.id === "panama-exports") {
          window.location.href = getIntelUrl() + "panama-search-export";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelArgentina) {
      if (userProductAccess.includes(localProductDictionary.intelArgentina) === true) {
        const tempArPlanObj = { user_active_plan: tempArPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempArPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        window.location.href = url;
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelUk) {
      if (userProductAccess.includes(localProductDictionary.intelUk) === true) {
        const tempUkPlanObj = { user_active_plan: tempUkPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempUkPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);

        if (label.props.id === "uk-exports") {
          window.location.href = getIntelUrl() + "uk-search-export";
        } else if (label.props.id === "uk-imports") {
          window.location.href = getIntelUrl() + "uk-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelIndonesia) {
      if (userProductAccess.includes(localProductDictionary.intelIndonesia) === true) {
        const tempIndonesiaPlanObj = { user_active_plan: tempSasPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempIndonesiaPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);

        if (label.props.id === "indonesia-exports") {
          window.location.href = getIntelUrl() + "indonesia-search-export";
        } else if (label.props.id === "indonesia-imports") {
          window.location.href = getIntelUrl() + "indonesia-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelPhilippines) {
      if (userProductAccess.includes(localProductDictionary.intelPhilippines) === true) {
        const tempPhilippinesPlanObj = { user_active_plan: tempPhPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempPhilippinesPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);

        if (label.props.id === "philippines-exports") {
          window.location.href = getIntelUrl() + "philippines-search-export";
        } else if (label.props.id === "philippines-imports") {
          window.location.href = getIntelUrl() + "philippines-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelVietnam) {
      if (userProductAccess.includes(localProductDictionary.intelVietnam) === true) {
        const intelVietnamPlanObj = { user_active_plan: tempVnPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", intelVietnamPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);

        if (label.props.id === "vietnam-exports") {
          window.location.href = getIntelUrl() + "vietnam-search-export";
        } else if (label.props.id === "vietnam-imports") {
          window.location.href = getIntelUrl() + "vietnam-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else if (data === localProductDictionary.intelIndia) {
      if (userProductAccess.includes(localProductDictionary.intelIndia) === true) {
        const intelIndiaPlanObj = { user_active_plan: tempInPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", intelIndiaPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);

        if (label.props.id === "india-exports") {
          window.location.href = getIntelUrl() + "india-search-export";
        } else if (label.props.id === "india-imports") {
          window.location.href = getIntelUrl() + "india-search-import";
        }
      } else {
        callNavigation("plans", data);
      }
    } else {
      if (userProductAccess.includes(localProductDictionary.intelMexico) === true) {
        const tempMxPlanObj = { user_active_plan: tempMxPlan };
        localStorageService.setDataToLocalStorage("userCurrentPlan", tempMxPlanObj);
        localStorageService.setDataToLocalStorage("userData", userData);
        if (!!mexicoBlockUsers[emailId] && mexicoBlockUsers[emailId] === true) {
          window.location.href =
            getIntelUrl() +
            "intel?T=" +
            localStorageService.getAccessToken() +
            "&I=" +
            localStorageService.getSessionID() +
            "&D=" +
            localStorageService.getSessionExpiryDate() +
            "&Type=D&P=" +
            data +
            "&Email=" +
            emailId +
            "&OId=" +
            (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 1);
        } else {
          if (label.props.id === "mexico-exports") {
            window.location.href = getIntelUrl() + "mexico-search-export";
          } else if (label.props.id === "mexico-imports") {
            window.location.href = getIntelUrl() + "mexico-search-import";
          }
        }
      } else {
        callNavigation("plans", data);
      }
    }
  };
  const logoutButtonFunction = () => {
    axios
      .get(intelHeader.logoutUser)
      .then((res) => {
        if (res.data.status.toLocaleUpperCase() === "success".toLocaleUpperCase()) {
          localStorageService.clearCompleteStorage();
          window.location.href = getAccountsUrl() + "signout";
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => console.log("Got Error", err));
  };
  const callNavigation = (type, data, redirectionUrl = "") => {
    let url = "";
    if (type === "plans") {
      url =
        getPaymentsUrl() +
        "payment?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        type +
        "&P=" +
        (!!data && data !== "" ? data : localStorageService.getUserProduct()) +
        "&OId=" +
        (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 3) +
        "&N=" +
        localStorageService.getNavigate();
    } else if (type === "payment-method") {
      url =
        getPaymentsUrl() +
        "payment?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        type +
        "&P=" +
        (!!data && data !== "" ? data : localStorageService.getUserProduct()) +
        "&OId=" +
        (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 3) +
        "&N=" +
        localStorageService.getNavigate();
    } else if (type === "profile") {
      url =
        getAccountsUrl() +
        "accounts?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        type +
        "&P=" +
        (!!data && data !== "" ? data : localStorageService.getUserProduct()) +
        "&OId=" +
        (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 3) +
        "&N=" +
        localStorageService.getNavigate();
    } else {
      url = redirectionUrl ? redirectionUrl : window.location.href;
    }
    window.location.href = url;
  };

  const callNavigationRedirection = (type, data, redirectionUrl) => {
    let url = "";
    if (type === "plans") {
      url =
        getPaymentsUrl() +
        "payment?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        type +
        "&P=" +
        (!!data && data !== "" ? data : localStorageService.getUserProduct()) +
        "&OId=" +
        localStorageService.getOptionId() +
        "&N=" +
        localStorageService.getNavigate();
    } else if (type === "payment-method") {
      url =
        getPaymentsUrl() +
        "payment?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        type +
        "&P=" +
        (!!data && data !== "" ? data : localStorageService.getUserProduct()) +
        "&OId=" +
        localStorageService.getOptionId() +
        "&N=" +
        localStorageService.getNavigate();
    } else if (type === "profile") {
      url =
        getAccountsUrl() +
        "accounts?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        type +
        "&P=" +
        (!!data && data !== "" ? data : localStorageService.getUserProduct()) +
        "&OId=" +
        localStorageService.getOptionId() +
        "&N=" +
        localStorageService.getNavigate();
    } else {
      url = redirectionUrl ? redirectionUrl : window.location.href;
    }
    window.location.href = url;
  };

  const callGetPlansByUserId = async () => {
    setLoader(true);
    try {
      const res = await axios.post(intelHeader.getPlansByUserId);
      const resdata = await res.data;
      setPlansData(resdata.data);
      let userData = localStorageService.getUserData();
      userData.tc_plans = resdata.data;
      localStorageService.setDataToLocalStorage("userData", userData);
      localStorageService.setDataToLocalStorage("tcUserData", resdata);
    } catch (err) {
      toast.error(err);
    } finally {
      setLoader(false);
    }
  };

  const goTo = () => {
    if (currentProduct.toLowerCase().includes("compliance")) {
      const url =
        getTradeComplianceUrl() +
        "?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&P=trade-compliance" +
        "&Email=" +
        emailId +
        "&OId=" +
        (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 3);
      window.location.href = url;
    } else if (currentProduct.toLowerCase().includes("sanction")) {
      const url =
        getSanctionsUrl() +
        "?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&Type=D&P=sanctions" +
        "&Email=" +
        emailId +
        "&OId=" +
        (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 3);
      window.location.href = url;
    } else {
      const url =
        getIntelUrl() +
        "intel?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&Type=D&P=" +
        currentProduct +
        "&Email=" +
        emailId +
        "&OId=" +
        (localStorageService.getOptionId() ? +localStorageService.getOptionId() : 3);
      window.location.href = url;
    }
  };

  const showChat = () => {
    window.$zoho && window.$zoho.salesiq.floatwindow.visible("show");
  };

  const handleUmsRedirection = () => {
    const { redirectionKey, redirectionUrl } = umsRedirection();
    callNavigation(redirectionKey, "", redirectionUrl);
  };

  return (
    <>
      <nav className="navbar navbar-dark navbar-expand-md fixed-top trademo-product-header">
        {isAccountExpired !== "" && isAccountExpired === false && userProductAccess.includes(currentProduct) === true ? (
          <span className="navbar-brand mx-auto pr-4 cursor-pointer" onClick={() => goTo()}>
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1645085709/global/trademo_logo/justLogo_mr5y0j.svg" alt="dashboard logo" />
          </span>
        ) : (
          <span className="navbar-brand mx-auto pr-4">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1645085709/global/trademo_logo/justLogo_mr5y0j.svg" alt="dashboard logo" />
          </span>
        )}
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <span className="d-none"></span> :
          <ul className="navbar-nav mr-md-auto">
            <span className="users-button">Plans</span>
          </ul>
          <ul className={!!isAccountExpired && isAccountExpired === true ? "navbar-nav my-lg-0 ml-md-auto" : "navbar-nav my-lg-0 ml-auto"}>
            <li id="all-app" className="nav-item my-auto">
              <a
                className="dropdown-toggle nav-link nav-link-product-dropdown intel-pill"
                href="#"
                id="navbarDropdownmultiple"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <img src={"https://res.cloudinary.com/drzta9shk/image/upload/v1657783264/intel/icons/header-cross-product-nav-icon_h1vqkd.svg"} alt="caretr_icon" className="" />
                <span className="pl-1">All Apps</span>
              </a>
              <div id="header-product-linking" className="dropdown-menu dropdown-menu-multiple p-2 header-product-linking-dropdown" aria-labelledby="navbarDropdown">
                {!!userData && Object.keys(userData).length && !!userData.parent_product_mapping && userData.parent_product_mapping.length ? (
                  <ProductLinkingDropdown
                    isAdmin={userData.isAdmin}
                    parentProductArr={userData.parent_product_mapping}
                    callNavigation={(key1, key2, key3) => callNavigationRedirection(key1, key2, key3)}
                    email={userData.email}
                  />
                ) : (
                  <></>
                )}
              </div>
            </li>
            {/* <li className="headway-app-widget"></li> */}
            <li className="nav-item my-auto">
              <a className="dropdown-toggle nav-link nav-user" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span className="text-capitalize" data-letters={!!initials && initials !== "" ? initials : "NA"}></span>
                {/* <img src={Careticon} alt="caretr_icon" className="mx-1"/> */}
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item cursor-pointer pb-9 hover-bg-none">
                  <span className="text-truncate user-dropdown-name cursor-default">
                    <span className="text-capitalize user-dropdown-left" data-letters={!!initials && initials !== "" ? initials : "NA"}></span>
                    <span className="user-dropdown-right">
                      <span className="name text-capitalize">{!!fullName && fullName !== "" ? fullName : "User"}</span>
                      <span className="email">{!!emailId && emailId !== "" && emailId.toLowerCase()}</span>
                    </span>
                  </span>
                </a>
                <div className="dropdown-divider my-0"></div>
                <a className="dropdown-item user-dropdown-items cursor-pointer pb-9 background-color-red" onClick={() => callNavigation("profile")}>
                  Profile Details
                </a>
                <a className="dropdown-item user-dropdown-items cursor-pointer pb-9 background-color-red">Plan Details</a>
                {/* {!!userplan && userplan !== '' && !!currentProduct && currentProduct !== '' && ((userplan !== upgradePlansDictionary.trademo_intel_us_free.key && currentProduct === localProductDictionary.intelUs) || (userplan !== upgradeMexicoPlansDictionary.trademo_intel_mx_free.key && currentProduct === localProductDictionary.intelMexico)) ? <a className="dropdown-item cursor-pointer" onClick={() => callNavigation('payment-method')}>Payment Method</a> : <span className="d-none"></span>} */}
                {isAdmin ? (
                  <>
                    <div className="dropdown-divider my-0"></div>
                    <a className="dropdown-item user-dropdown-items cursor-pointer pb-9 background-color-red" onClick={handleUmsRedirection}>
                      User Management System
                    </a>
                  </>
                ) : null}
                <div className="dropdown-divider my-0"></div>
                {/* <a rel="noopener noreferrer" className="dropdown-item user-dropdown-items cursor-pointer pb-9 background-color-red" onClick={() => showChat()}>
                                <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1707728252/intel/icons/fwauojuugtoru3lhgybi.svg" alt="chat-icon" />
                                    Chat with Us
                                </a> */}
                {!!currentProduct && localProductDictionary[currentProduct] !== undefined ? (
                  <>
                    <div className="dropdown-divider my-0"></div>
                    <a
                      href={getWebsiteUrl() + "support"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item user-dropdown-items cursor-pointer pb-9 background-color-red">
                      Support
                    </a>
                  </>
                ) : (
                  <></>
                )}
                <div className="dropdown-divider my-0"></div>
                <a onClick={() => logoutButtonFunction()} className="dropdown-item user-dropdown-items cursor-pointer pb-9 background-color-red">
                  <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1707728252/intel/icons/xkb7yvj12tnggbc5ptve.svg" alt="sign-out-icon" />
                  Sign Out
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      {loader && <Loader />}
    </>
  );
}
